import React from 'react'

import { Box, Typography } from '@material-ui/core'

import useStyles from './SidebarStyles'

export default function SidebarMonthToMonth({
  duration,
  amount,
  isFinalPrice,
  isTariff,
  className,
  isBundle,
}: {
  duration: string
  amount: string
  isFinalPrice?: boolean
  className?: string
  isTariff?: boolean
  isBundle?: boolean
}) {
  const { greyColor } = useStyles()
  return (
    <Box>
      <Box display="flex" justifyContent="space-between" width="100%" mb={3} className={className}>
        <Box display="flex" alignItems="baseline" pl={isBundle ? 2 : 0}>
          {isBundle && '-'}
          <Typography
            component={Box}
            pl={isBundle ? 1 : 0}
            variant={isFinalPrice ? 'h5' : 'body2'}
            className={!isFinalPrice ? greyColor : ''}
          >
            {isTariff ? `Cuota ${duration.toLowerCase()}` : duration}
          </Typography>
        </Box>
        {amount !== '0,00' ? (
          <Typography variant="body1" className={!isFinalPrice ? greyColor : ''}>
            <strong>{amount} </strong>
            €/mes
          </Typography>
        ) : (
          <Typography variant="body1" className={!isFinalPrice ? greyColor : ''}>
            <strong>Gratis</strong>
          </Typography>
        )}
      </Box>
    </Box>
  )
}
